import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[testId]',
    standalone: true
})
export class TestIdDirective {
    @Input() testId: string;

    @HostBinding('attr.data-test-id')
    get testDataId(): string {
        return this.testId;
    }
}
